<template>
  <el-card v-show="visible">
    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4" v-for="record of tableData" :key="record.code">
          <div class="card">
            <div class="card-body p-3">
              <div class="row">
                <div class="col-9">
                  <div class="numbers">
                    <p class="text-sm mb-0 text-uppercase font-weight-bold">
                      <el-radio v-model="cardpost" :label="record.code">{{ record.code }}</el-radio>
                    </p>
                  </div>
                </div>
                <div class="col-3 text-end">
                  <span class="badge badge-primary badge-pill">{{ record.total }} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-form label-position="top">
        <el-row type="flex">
          <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item :label="$t('cliente')" prop="name">
              <CustomerList v-model="customer" />
            </el-form-item>
            <el-button type="primary" autofocus @click="apply()">{{
              $t("aplicar")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
</template>
<script>
import { AuditService } from "@/services/customers/audit.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import AuditPendenciesOptions from './AuditPendenciesOptions';

export default {
  name: "AuditList",
  props: ["type"],
  components: {
    AuditPendenciesOptions,
    CustomerList,
  },
  data() {
    return {
      visible: false,
      tableData: [],
      cardpost: '',
      customer: '',
    }
  },  
  methods: {
    show() {
      this.visible = true;
      this.fetchRecords();
    },
    hide() {
      this.visible = false;
    },
    apply() {
      const vm = this;
      if (!vm.cardpost || !vm.customer) {
        return vm.$message({ type: "error", message: 'Selecione o cliente e o cartão de postagem!' });
      }
      const loading = vm.$loading(vm.$options.loading);
      AuditService.link(vm.cardpost, vm.customer)
        .then((response) => {
          vm.$message({ type: "success", message: 'Cliente setado nas pendências de auditoria conforme o cartão de postagem!' });
          vm.$emit('reload');
          vm.visible = false;
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      vm.tableData = [];
      const loading = vm.$loading(vm.$options.loading);
      setTimeout(() => {
        AuditService.cardpost(vm.type)
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
      }, 200)
    },
  },
};
</script>
<style scoped>
.list-group-item {
  padding-top: 15px !important;
}
</style>